/**
 * Picture
 * 
 * @Author: Focci
 * @Date: 2024-06-13 09:14:49
 * @Last Modified by: Focci
 * @Last Modified time: 2024-06-13 09:14:49
 */

// import PropTypes from 'prop-types'
import clsx from 'clsx'
import { get } from 'lodash-es'
import Image, { getImageProps } from 'next/image'
import { useState } from 'react'

export default function Picture({
  src,
  mobileSrc,
  width,
  height,
  mobileWidth = width,
  mobileHeight = height,
  hoverZoomIn = false,
  transition = true,
  wrapClassName = '',
  className = 'object-cover',
  priority = false,
  ...imageProps
}) {
  const [ready, setReady] = useState(false)

  if (!src && !mobileSrc) return null

  const url = src || mobileSrc || ''
  const murl = mobileSrc || src || ''
  const isSvg = /.svg$/i.test(get(url, 'src', url))

  const common = { unoptimized: isSvg || undefined, priority }
  const { 
    props: { srcSet: desktop, ...rest } 
  } = getImageProps({ ...common, src: url, width, height })
  const { 
    props: { srcSet: mobile } 
  } = getImageProps({ ...common, src: murl, width: mobileWidth, height: mobileHeight })
 
  return (
    <picture className={clsx(['w-full h-full flex', wrapClassName])}>
      <source media="(min-width: 768px)" srcSet={isSvg ? get(url, 'src', url) : desktop} />
      <source media="(max-width: 767px)" srcSet={isSvg ? get(murl, 'src', murl) : mobile} />
      <Image 
        {...rest} 
        {...imageProps}
        className={clsx([
          'w-full h-full',
          transition && 'opacity-0',
          hoverZoomIn && 'transition-transform duration-1000 group-hover/aspect-ratio:scale-110',
          ready && transition && 'animate-fade-in',
          className
        ])}
        onLoad={() => setReady(true)} 
      />
    </picture>
  )
}

// Picture.propTypes = {
//   className: PropTypes.string,
// }
